import axios from 'axios';

const clockifyApi = axios.create({
    baseURL: 'https://api.clockify.me/api/v1/',
})

export default clockifyApi;